import { Box, Typography } from "@mui/material";
import moment from "moment";

const LayoutService = (props) => {
  const updatesServices = moment().format("DD MMMM YYYY");
  
  return (
    <Box className="main-page">
      <Box
        sx={{
          bgcolor: "#7495f8",
          color: "white",
          borderRadius: 2,
          px: 4,
          py: 5,
          mb: 3,
          position: "relative"
        }}
      >
        <Typography 
          variant="body2"
          className="date-boxHeader"
        >
          {updatesServices}
        </Typography>
        <Typography variant="h5">
          Administrador<br />
          de páginas y servicios
        </Typography>
        <Typography mt={2} variant="body1" color="primary">
          <small>Crea y administra tus páginas y servicios</small>
        </Typography>
      </Box>

      {props.children}
    </Box>
  );
}

export default LayoutService;
